import { BasicChangeLanguageCommand, LanguageDataEvent } from "@goodgamestudios/core";
import { Poker2LayoutManager } from "../../view/Poker2LayoutManager";

export class Poker2ChangeLanguageCommand extends BasicChangeLanguageCommand {
    public static NAME = "Poker2ChangeLanguageCommand";

    protected onFontLoadComplete(event: LanguageDataEvent): void {
        super.onFontLoadComplete(event);
        Poker2LayoutManager.getInstance().onLanguageChangedAndFontReady();
    }

}
